import moment, { Moment } from 'moment';

export const convertUtcToLocal = (utcDate: string): Moment => {
  let momentDate = moment.utc(utcDate, moment.ISO_8601, true);

  // If not valid, try the custom format
  if (!momentDate.isValid()) {
    const customFormat = 'MMM D, YYYY h:mm A';
    momentDate = moment.utc(utcDate, customFormat, true);
  }

  return momentDate.local();
};

const convertLocalToUtc = (localDate: string): string => {
  return moment(localDate).utc().format();
};

export const convertDateFilterToUtc = (
  dateFilter: Record<string, string>,
): any => {
  let convertedDateTime = JSON.parse(JSON.stringify(dateFilter));

  if (dateFilter && dateFilter.from && dateFilter.to) {
    const fromDateTime = moment(dateFilter.from, 'YYYY/MM/DD').format(
      'YYYY-MM-DD 00:00:00',
    );
    const toDateTime = moment(dateFilter.to, 'YYYY/MM/DD').format(
      'YYYY-MM-DD 23:59:59',
    );

    convertedDateTime = {
      from: convertLocalToUtc(fromDateTime),
      to: convertLocalToUtc(toDateTime),
    };
  }

  return convertedDateTime;
};

export const convertFilter = (filter: Record<string, any>) => {
  let convertedFilter = JSON.parse(JSON.stringify(filter));

  if (filter.date) {
    convertedFilter.date = convertDateFilterToUtc(convertedFilter.date as any);
  }

  return convertedFilter;
};
